import { useContext } from 'react';

import { FifteenDelayDisapproval, MscDisapproval } from '@/components';
import { StudentContext } from '@/contexts';
import { useClient } from '@/hooks';

const PaymentMethodComponents: Record<string, React.FC> = {
  fifteen_delay: FifteenDelayDisapproval,
  msc: MscDisapproval,
};

const Disapproval: React.FC = () => {
  const { state } = useContext(StudentContext);
  const { stateMachineVersion } = useClient();

  const isV3 = stateMachineVersion === 'V3';

  const paymentMethod = isV3 ? 'msc' : state.paymentMethod;

  const PaymentMethodDisapproval = PaymentMethodComponents[
    paymentMethod
  ] as React.FC;

  return <PaymentMethodDisapproval />;
};

export default Disapproval;
